import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { AppProviders } from '@/app/providers/AppProviders';
import { router } from '@/app/router/router';
import { reportError } from '@/shared/observability/report-error';
import '@/styles/index.css';

createRoot(document.getElementById('root'), {
  onCaughtError: reportError,
  onUncaughtError: reportError,
  onRecoverableError: reportError,
}).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
